<template>
  <div class="about">
    <h1>{{appTitle}}</h1>
    <p>by Goeland Dev Team</p>
    <p>City of Lausanne - Switzerland</p>
  </div>
</template>
<script>
import {
  APP,
  DEV,
  getLog, VERSION,
} from '../config';

const MODULE_NAME = 'About';
const log = getLog(MODULE_NAME, 4, 2);
export default {
  name: 'About',
  props: {
    isLoading: {
      type: Boolean,
      default: true,
    },
    isUserAdmin: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    appName: APP,
    appTitle: `${APP} - ${VERSION}`,
    isInDev: DEV,
  }),
  mounted() {
    log.t(`# ${MODULE_NAME} mounted()`);
  }, // end of mounted
};
</script>
